import clsx from 'clsx'

export function GreyDivider({ className = '' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 390 6"
      fill="none"
      className={clsx('w-full', className)}
    >
      <path
        d="M0.113249 3L3 5.88675L5.88675 3L3 0.113249L0.113249 3ZM389.887 3.00006L387 0.113304L384.113 3.00006L387 5.88681L389.887 3.00006ZM3 3.5L387 3.50006L387 2.50006L3 2.5L3 3.5Z"
        fill="white"
        fillOpacity="0.2"
      />
    </svg>
  )
}
